import api from './api';

export const proformaService = {
    getAllProformaInvoices: (params) => api.get('/proforma', { params }),
    getProformaInvoice: (id) => api.get(`/proforma/${id}`),

    createProformaInvoice: (data) => api.post('/proforma', data),

    getNextProformaNumber: (companyId, date) => api.get('/proforma/next-number', { params: { companyId, date } }),

    deleteProformaInvoice: (id) => api.delete(`/proforma/${id}`),
    getProformaStats: (params) => api.get('/proforma/stats', { params }),
    exportProformaInvoice: (id) => api.get(`/proforma/${id}/export`, { responseType: 'blob' }),
};

